export const AVATAR_COLORS = [
    '#FF6B6B',
    '#4ECDC4',
    '#45B7D1',
    '#FFA07A',
    '#98D8C8',
    '#F7DC6F',
    '#BB8FCE',
    '#85C1E2',
    '#F8B88B',
    '#ABEBC6',
    '#FAD7A0',
    '#D7BDE2',
];
export function hashString(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) + hash + str.charCodeAt(i);
    }
    return Math.abs(hash);
}
export function generateAvatarColor(nickname) {
    if (!nickname || typeof nickname !== 'string') {
        return AVATAR_COLORS[0];
    }
    const normalizedNickname = nickname.trim().toLowerCase();
    if (normalizedNickname.length === 0) {
        return AVATAR_COLORS[0];
    }
    const hash = hashString(normalizedNickname);
    const colorIndex = hash % AVATAR_COLORS.length;
    return AVATAR_COLORS[colorIndex];
}
function convertChannel(c) {
    const channel = c / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
function calculateLuminance(r, g, b) {
    const rs = convertChannel(r);
    const gs = convertChannel(g);
    const bs = convertChannel(b);
    return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}
export function getContrastTextColor(hexColor) {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = calculateLuminance(r, g, b);
    return luminance > 0.5 ? 'black' : 'white';
}
//# sourceMappingURL=avatar-colors.js.map